<template> 
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item @click="redireccionarMyStudents">Classes</b-breadcrumb-item>
            <b-breadcrumb-item active>{{dataStudent.name}}: 
                <span v-if="tabIndex==0">Student Reports</span>
                <span v-else>Assignments & Evaluations</span>
            </b-breadcrumb-item>
        </b-breadcrumb>

        
        <b-tabs v-model="tabIndex" class="sm" style="margin-bottom:20px;">
            <b-tab title="Student Reports" @click="changueParams(0)" :disabled="disabledTabReport">
                <div class="back-step mt-0"  @click="redireccionarMyStudents">
                    <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                </div>
                <b-row class="evaluationCourse">
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <b-avatar
                            variant="light"
                            :src="urlPhoto"
                            ></b-avatar> 
                            <div>
                                <span class="blue">Student:</span>
                                <p>{{dataStudent.name}}</p>
                                <p>{{dataStudent.flag ? `(${dataStudent.groupsCode})`: ''}}</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">Courses:</span>
                                <p v-if="flagHistory">{{nameSubject ?  nameSubject : '-'  }}</p>
                                <p v-else v-for="(item ,index) in dataStudent.subjectsStr" :key="index">{{item}}</p>
                             
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Assignments & Evaluations" @click="changueParams(1)" :disabled="disabledTabEvaluat">
                <div class="back-step mt-0"  @click="backStep">
                    <img class="svg" src="@/assets/icons/icon-arrow-left.svg">{{$t('planesYPrecios.regresar')}}
                </div>
                <b-row class="evaluationCourse">
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <b-avatar
                            variant="light"
                             :src="urlPhoto"
                            ></b-avatar>
                            <div>
                                <span class="blue">Student:</span>
                                <p>{{dataStudent.name}}</p>
                                <p>{{dataStudent.flag ? `(${dataStudent.groupsCode})`: ''}}</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col class="justify-content-center">
                        <div class="sub-title-img name">
                            <img src="@/assets/img/progress-small.png">
                            <div>
                                <span class="blue">Courses:</span>
                                <p v-if="flagHistory">{{nameSubject}}</p>
                                <p v-else v-for="(item ,index) in dataStudent.subjectsStr" :key="index">{{item}}</p>
                             
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
        <div class="card">
            <div class="card-body">
                <template  v-if="tabIndex==0">
                    <studentReports :TabClassRequest="this.$route.params.TabClassRequest" :typeStudent="this.$route.params.typeStudent" />
                </template>
                <template v-else>
                    <assignmentsEvaluations/>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import assignmentsEvaluations from "@/views/teacher/student/assignments-evaluations"
import studentReports from "@/views/teacher/student/student-reports"
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import { IMAGENES } from '@/assets/js/appConstants'; 
import * as tools from '@/assets/js/tools.js';
export default {
    data(){
        return{
            urlPhoto: IMAGENES.PHOTO_STUDENT_DEFAULT,
  
            tabIndex: 0,
            dataStudent : {},
            groupId:  0 ,
            groupPlanId : 0,
            flagHistory : false,
            nameSubject : '',
            personStudentId : 0
        }
    },
    components:{
        assignmentsEvaluations,
        studentReports
    },
    computed:{
        disabledTabReport(){
            if(this.flagHistory){
                  if(this.$route.params.disabledTab==2){
                    return true
                }
            }
            return false;
        },
        disabledTabEvaluat(){
            if(this.flagHistory){
                 if(this.$route.params.disabledTab==1){
                    return true
                }
            }
            return false;
        },
        
    },
    created(){
        

        if(this.$route.params.groupId == undefined){
                this.$router.push({
                        name : 'teacher/student',
                    
                    }).catch(err => {}); 
            }else{
                this.groupId = this.$route.params.groupId
                this.personStudentId = this.$route.params.personStudentId
                this.groupPlanId = this.$route.params.groupPlanId
                this.nameSubject = this.$route.params.nameSubject
                this.flagHistory = this.$route.params.flagHistory
                this.getDataStudent();
                this.methodSvg();
                this.validIdRouter();
        }
 
       
    },
    watch:{
        tabIndex(val){
            this.methodSvg()
        }
    },
    methods:{
        getDataStudent(){
            let data = {
                groupId : this.groupId,
                personStudentId : this.personStudentId
            }
    
            baseInstanceAxios
            .get(`${this.apiURL}/Resources/PersonsStudents/GetGroupByPersonStudent`,{
                params : data
            } )
            .then(response => {
               this.dataStudent = {
                   name : response.data.entity.person.strFullName,
                   groupsCode : response.data.entity.groupsCode,
                   flag : response.data.entity.flagGroup,
                   subjectsStr : response.data.entity.subjectsStr_EN  ?  response.data.entity.subjectsStr_EN.split("|") : [],
               }
               
                if(response.data.entity.flagGroup){
                     this.urlPhoto = IMAGENES.PHOTO_STUDENT_DEFAULT
                }else{
                    if(response.data.entity.person.photo)
                        this.urlPhoto = response.data.entity.person.photo;
                }
            
            });
        },
        // changedTab(val) {
        //     debugger;
        //     // this.$route.params.id=val
        //     this.methodSvg()
        // },
        changueParams(val){
            /*this.$router.replace("/teacher/student/evaluations-reports/"+val)*/

            this.$router.replace({name : 'teacher-student-evaluations-reports' , params :
            { 
                id : val , 
                flagHistory : this.flagHistory,
                groupId : this.groupId  ,
                groupPlanId:this.groupPlanId, 
                personStudentId : this.personStudentId, 
                nameSubject :this.nameSubject,
                flagTab : false
            } 
            })
        },
        validIdRouter(){
            this.tabIndex =  parseInt(this.$route.params.id)
        },
        methodSvg(){
        //importante para los iconos, arriba esta la importación ----------------
            this.$nextTick(function () {
                tools.imgToSvg()
            })
        },
        backStep(){
            this.$router.push({path : '/teacher/class'})
        },
        redireccionarMyStudents(){
           this.$router.push({path : '/teacher/class' , params : 
            { 
                type : this.$route.params.TabClassRequest, 
                typeStudent: this.$route.params.typeStudent
            }})
        }
    }
}
</script>